import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="reports--form"
export default class extends Controller {
  static targets = [
    "customTimeZoneSelector",
    "customTimeZoneRadioButton",
    "headerImage",
    "headerImageSetting",
  ];

  connect() {
    this.toggleCustomTimeZoneField();
  }

  toggleCustomTimeZoneField() {
    this.customTimeZoneSelectorTarget.classList.toggle(
      "d-none",
      !this.customTimeZoneRadioButtonTarget.checked
    );
  }

  headerImageTargetConnected() {
    this.setImageSettingVisibility(true);
  }

  headerImageTargetDisconnected() {
    this.setImageSettingVisibility(false);
  }

  changedImage(ev) {
    if (ev.target.files.length === 1) {
      this.setImageSettingVisibility(true);
    } else {
      this.setImageSettingVisibility(false);
    }
  }

  setImageSettingVisibility(visible) {
    this.headerImageSettingTargets.forEach((target) => {
      target.classList.toggle("d-none", !visible);
    });
  }
}
